import React from 'react';
import renderImageNode from '../../common/renderImageNode.js';
import renderTitleNode from '../../common/renderTitleNode.js';
import '../../style/index.less.js';

var Native = function Native(props) {
  var image = props.image,
    title = props.title;
  return /*#__PURE__*/React.createElement("div", {
    className: "ti-exception"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ti-exception-image"
  }, renderImageNode(image)), /*#__PURE__*/React.createElement("div", {
    className: "ti-exception-title"
  }, renderTitleNode(title)));
};

export { Native as default };
